export default "__VITE_ASSET__OkOnVxeH__"